import moment from 'moment';
import { debounce } from 'lodash';
import { api } from '@/utils';

export default {
  name: 'DossierAssigner',
  components: {},
  props: {
    inputForm: {
      type: Object,
      default: undefined,
    },
    inputFormType: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    title: 'Dossier',
    selectedDossier: null,
    formFields: {
      dossier: {
        name: 'dossier',
        validation: 'required',
      },
    },
    // search props
    apiVersion: 1,
    pageSize: 10,
    isLoadingDossier: false,
    dossierEntries: [],
    searchDossier: null,
  }),
  computed: {
    dossierItems() {
      return this.dossierEntries.map((entry) => {
        let autocompleteValue = `${entry.dossierNumber} - ${entry.vesselName} - ${entry.terminal}`;

        if (entry.voyageEstimateArrivalDateTime != null) {
          autocompleteValue += ` - ${moment(entry.voyageEstimateArrivalDateTime).format('YYYY-MM-DD hh:MM:ss')}`;
        }

        return Object.assign({}, entry, { autocompleteValue });
      });
    },
  },
  methods: {
    setDossier(dossierId) {
      // BASEURL
      const url = `/dossiers/${dossierId}`;

      api.get(url)
        .then((response) => {
          // eslint-disable-next-line
          response.data.vesselName = response.data.vessel.name;
          // eslint-disable-next-line
          response.data.vesselTypeCode = response.data.vessel.vesselTypeCode;

          this.dossierEntries.push(response.data);
          this.selectedDossier = response.data;
          this.$eventHub.$emit('prefill-clientinfo', this.selectedDossier);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchDossiers: debounce(function fetchDossiers() {
      this.isLoadingDossier = true;

      // BASEURL
      let url = '/dossiers?';

      // Page and Pagesize
      url += `&page=1&page-size=${this.pageSize}`;

      // Free text
      url += `&free-text=${this.searchDossier}`;

      api.get(url)
        .then((response) => {
          this.dossierEntries = response.data;
          this.isLoadingDossier = false;
        })
        .catch((error) => {
          console.log(error);
        });
    }, 300),
    onInputFormSaved: debounce(function saved() {
      if (this.selectedDossier != null) {
        this.$eventHub.$emit('fetch-dossier-id', this.selectedDossier.id);
      }
    }, 300),
    onRelinkInputForm() {
      if (this.selectedDossier != null) {
        this.$eventHub.$emit('fetch-dossier-id', this.selectedDossier.id);
      }
    },
  },
  watch: {
    searchDossier() {
      let dontSearch = false;

      this.dossierItems.forEach((dossierItem) => {
        if (dossierItem.autocompleteValue === this.searchDossier) {
          dontSearch = true;
        }
      });

      if (!dontSearch) {
        this.searchDossiers();
      }
    },
    selectedDossier() {
      this.$eventHub.$emit('prefill-clientinfo', this.selectedDossier);
      this.$eventHub.$emit('dossier-selected-in-dossier-assigner', this.selectedDossier != null ? this.selectedDossier.id : null);
    },
    inputForm() {
      if (this.inputForm.link != null) {
        this.setDossier(this.inputForm.link.dossierId);
      } else if (this.inputForm.links.length > 0) {
        this.setDossier(this.inputForm.links[0].dossierId);
      }
    },
  },
  created() {
    if (this.$route.query.dossierId != null) {
      this.setDossier(this.$route.query.dossierId);
    }

    this.$eventHub.$on('on-input-form-saved', this.onInputFormSaved);
    this.$eventHub.$on('on-relink-input-form', this.onRelinkInputForm);
  },
};
